'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getCartOptions = getCartOptions;
exports.getCartChangeKey = getCartChangeKey;
exports.getCartAmountFor = getCartAmountFor;

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCartOptions(cart) {
    var props = ['deliveryTypeId', 'paymentTypeId', 'pickupPlaceId', 'selectedFreeProducts', 'financialInstitutionId', 'note'];
    return _extends({}, (0, _pick2.default)(cart, props), cart.changedOptions);
}

function getCartChangeKey(action) {
    var changeKey = [];
    if (action.giftId) changeKey.push('gift_' + action.giftId);else if (action.productId) changeKey.push(action.productId);

    if (action.customerId) changeKey.push(action.customerId);
    return changeKey.join();
}

function getCartAmountFor(item, state) {
    var amount = item.amount;
    var key = getCartChangeKey(item);
    var changed = state.cart.changes[key];
    var updating = state.cart.updating[key];
    if (changed && typeof changed.amount === 'number') {
        amount = changed.amount;
    } else if (updating && typeof updating.amount === 'number') {
        amount = updating.amount;
    } else {
        if (item.giftId > 0) {
            var giftItem = state.cart.giftItems.find(function (g) {
                return g.giftId === item.giftId;
            });
            if (giftItem) {
                amount = giftItem.amount;
            }
        } else {
            var itemAmount = state.cart.itemAmounts.find(function (i) {
                return i.productId === item.productId;
            });
            if (itemAmount) {
                amount = itemAmount.amount;
            }
        }
    }
    return amount;
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/cart.js
// module id = 466
// module chunks = 0